import axios from 'axios';
import {getHeader} from './user_api';
import {
    REPORT_ACTIONS_API_URL,
    REPORT_TITLE_IMAGE_API_URL,
    REPORT_SOC_IMAGE_API_URL,
    REPORT_PHOTO_LINK_UPDATE_API_URL,
    ROOM_TEMPLATE_API_URL
} from "../constants/api_routes";

export const getReportById = async (URL, reportId) => {
    try {
        const res = await axios.get(`${URL}/${reportId}`, {headers: getHeader()});
        return res.data;
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const uploadTitleImage = async (formData) => {
    try {
        await axios.post(`${REPORT_TITLE_IMAGE_API_URL}`, formData , {headers: getHeader()});
        return ({
            success:true,
            statusMessage:"File Successfully uploaded"
        })
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const uploadSOCImage = async (formData) => {
    try {
        await axios.post(`${REPORT_SOC_IMAGE_API_URL}`, formData , {headers: getHeader()});
        return ({
            success:true,
            statusMessage:"File Successfully uploaded"
        })
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};
export const uploadOtherSOCImage = async (formData) => {
    try {
        await axios.post(`${REPORT_SOC_IMAGE_API_URL}_other`, formData , {headers: getHeader()});
        return ({
            success:true,
            statusMessage:"File Successfully uploaded"
        })
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const updatePhotoLink = async (formData) => {
    try {
        await axios.post(`${REPORT_PHOTO_LINK_UPDATE_API_URL}`, formData , {headers: getHeader()});
        return ({
            success:true,
            statusMessage:"Photo Link Successfully updated!!"
        })
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};


export const deleteImageFromReport = async (imageId) => {
    let res ={};
    try {
        res = await axios.delete(`${REPORT_ACTIONS_API_URL}/images/${imageId}`,{headers: getHeader()});
        return ({
            success:true,
            statusMessage:"Image Removed Successfully!"
        })

    } catch (error){
        return ({
            success:false,
            statusMessage:res.error
        })
    }
};

export const addImageForReport = async (formData) => {
    let response ={};
    try {
        response = await axios.post(`${REPORT_ACTIONS_API_URL}/images/upload`,formData,{headers: getHeader()});
        return ({
            success:true,
            statusMessage:"Image Uploaded Successfully!"
        })

    } catch (error){
        return ({
            success:false,
            statusMessage:error
        })
    }
};

export const submitReport = async (type, formData) => {
    try {
        const response = await axios.post(
            `${REPORT_ACTIONS_API_URL}/body/${type}`,
            formData,
            { headers: getHeader() }
        );

        if (response.data.success) {
            return {
                success: true,
                statusMessage: "Report Submitted Successfully!!",
            };
        } else {
            return {
                success: false,
                statusMessage: response.data.error
                    ? response.data.error
                    : "Unknown server error",
            };
        }
    } catch (error) {
        let message = "";

        if (error.response) {
            if (error.response.data) {
                if (error.response.data.error) {
                    message = error.response.data.error;
                } else if (error.response.data.message) {
                    message = error.response.data.message;
                } else {
                    message = "Server responded with an error but no details.";
                }
            } else {
                message = "Server responded with no data.";
            }
        } else if (error.request) {
            message = "No response received from server.";
        } else if (error.message) {
            message = error.message;
        } else {
            message = String(error);
        }

        return {
            success: false,
            statusMessage: message,
        };
    }
};


export const uploadKeyDetails = async (type,formData) => {
    let response;
    try {
        response = await axios.post(`${REPORT_ACTIONS_API_URL}/keys/${type}`,formData,{headers: getHeader()});
        if(response.data.success){
            return ({
                success:true,
                statusMessage:"Keys added Successfully!!"
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error
            })
        }

    } catch (error){
        if(error.response){
            return ({
                success:false,
                statusMessage:error.response.data.error
            })
        } else if (error.request) {
            return {
                success: false,
                statusMessage: "Network error: Please check your internet connection.",
            };
        }
    }
};


export const uploadAlarmDetails = async (type,formData) => {
    let response;
    try {
        response = await axios.post(`${REPORT_ACTIONS_API_URL}/alarms/${type}`,formData,{headers: getHeader()});
        if(response.data.success){
            return ({
                success:true,
                statusMessage:"Alarms added successfully !!"
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error
            })
        }

    } catch (error){
        if(error.response){
            return ({
                success:false,
                statusMessage:error.response.data.error
            })
        } else if (error.request) {
            return {
                success: false,
                statusMessage: "Network error: Please check your internet connection.",
            };
        }
    }
};

export const uploadReceiptsDetails = async (formData) => {
    let response;
    try {
        response = await axios.post(`${REPORT_ACTIONS_API_URL}/receipts/update`,formData,{headers: getHeader()});
        if(response.data.success || response.data[0]['client_id']){
            return ({
                success:true,
                statusMessage:"Receipts added successfully !!"
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error
            })
        }

    } catch (error){
        if(error.response){
            return ({
                success:false,
                statusMessage:error.response.data.error
            })
        } else if (error.request) {
            return {
                success: false,
                statusMessage: "Network error: Please check your internet connection.",
            };
        }
    }
};

export const getOldMeterDetails = async (inspectionId) => {
    let response;
    try {
        response = await axios.get(`${REPORT_ACTIONS_API_URL}/meters/history?inspection_id=${inspectionId}`,{headers: getHeader()});
        if(response.data.success){
            return ({
                success:true,
                statusMessage:"Meters history retrieved !!",
                meters:response.data.meters

            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error
            })
        }

    } catch (error){
        if(error.response){
            return ({
                success:false,
                statusMessage:error.response.data.error
            })
        } else if (error.request) {
            return {
                success: false,
                statusMessage: "Network error: Please check your internet connection.",
            };
        }
    }
};

export const uploadMeterDetails = async (type,formData) => {
    let response;
    try {
        response = await axios.post(`${REPORT_ACTIONS_API_URL}/meters/${type}`,formData,{headers: getHeader()});
        if(response.data.success){
            return ({
                success:true,
                statusMessage:"Meters added successfully !!"
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error
            })
        }

    } catch (error){
        if(error.response){
            return ({
                success:false,
                statusMessage:error.response.data.error
            })
        } else if (error.request) {
            return {
                success: false,
                statusMessage: "Network error: Please check your internet connection.",
            };
        }
    }
};

export const uploadDepositaryDetails = async (formData) => {
    let response;
    try {
        response = await axios.post(`${REPORT_ACTIONS_API_URL}/depositary/`, formData, { headers: getHeader() });
        if(response.data.success){
            return ({
                success: true,
                checkoutUploadResponse: response.data.checkoutUploadResponse,
                deductionsUploadResponse:response.data.deductionsUploadResponse,
                statusMessage:"Depositary added successfully !!"
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error
            })
        }

    } catch (error){
        return ({
            success:false,
            statusMessage:error.response.data.error
        })
    }
};

export const checkOrGeneratePDF = async (id) => {
    try {
        const res = await axios.get(`${REPORT_ACTIONS_API_URL}/checkpdf/${id}`, {headers: getHeader()});
        return ({
            success:true,
            statusMessage:"PDF Has been generated"
        })
    } catch (e) {
        return ({
            success:false,
            statusMessage:e.response.data.error
        })
    }
};

export const getSearchDepositaryAddress = async (address,reportId) => {
    try {
        const response = await axios.get(`${REPORT_ACTIONS_API_URL}/depositary/searchAddress?id=${reportId}&address=${address}`,{headers:getHeader()});
        if (response.data.error) {
            
            return {
                success: false,
                data: response.data.error,
            }
        } else
            return {success:true,data:response.data.tenancies?response.data.tenancies:[]}
    } catch (e) {
        return {
            success:false,
            data:e.message?e.message:"Something went wrong"
        }
    }
};

export const getPreviousReportsOfProperty = async (id,ins_type,custom = "false") => {
    try {
        const res = await axios.get(`${REPORT_ACTIONS_API_URL}/report_history?report_id=${id}&inspection_type=${ins_type}&custom=${custom}`, {headers: getHeader()});
        return res.data;
    } catch (e) {
        return ({
            success:false,
            statusMessage:"Something Went Wrong. Please Try Again!"
        })
    }
};

export const loadReport = async (reportId,formData) => {
    let response;
    try {
        response = await axios.post(`${REPORT_ACTIONS_API_URL}/load_report`,formData,{headers: getHeader(),timeout:0});
        if(response.data.success){
            return ({
                success:true,
                statusMessage:"Report Submitted Successfully!!"
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error?response.error:(response.data && response.data.message?response.data.message:"Error origin unknown")
            })
        }

    } catch (error){
        return ({
            success:false,
            statusMessage:error.response.error?error.response.error:(error.response.data && error.response.data.message?error.response.data.message:"Error origin unknown")
        })
    }
};

export const saveRoomTemplate = async (formData) => {
    let response;
    try {
        response = await axios.post(`${ROOM_TEMPLATE_API_URL}/create`,formData,{headers: getHeader()});
        if(response.data.success){
            return ({
                success:true,
                statusMessage:"Room Template Added Successfully!!"
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error
            })
        }

    } catch (error){
        return ({
            success:false,
            statusMessage:"Something Went Wrong. Please Try Again!"
        })
    }
};

export const getRoomTemplateList = async () => {
    try {
        const res = await axios.get(`${ROOM_TEMPLATE_API_URL}/list`, {headers: getHeader()});
        return ({
            success:true,
            data:res.data
        });
    } catch (e) {
        return ({
            success:false,
            statusMessage:"Something Went Wrong. Please Try Again!"
        })
    }
};

export const deleteRoomTemplate = async (roomTemplateID) => {
    try {
        const res = await axios.delete(`${ROOM_TEMPLATE_API_URL}/${roomTemplateID}`, {headers: getHeader()});
        return ({
            success:true,
            data:res.data
        });
    } catch (e) {
        return ({
            success:false,
            statusMessage:"Something Went Wrong. Please Try Again!"
        })
    }
};

export const uploadDisclaimerDetails = async (formData) => {
    let response;
    try {
        response = await axios.post(`${REPORT_ACTIONS_API_URL}/disclaimer/update`,formData,{headers: getHeader()});
        if(response.data.success || response.data[0]['client_id']){
            return ({
                success:true,
                statusMessage:"Disclaimers added successfully !!"
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error
            })
        }

    } catch (error){
        if(error.response){
            return ({
                success:false,
                statusMessage:error.response.data.error
            })
        } else if (error.request) {
            return {
                success: false,
                statusMessage: "Network error: Please check your internet connection.",
            };
        }
    }
};
export const uploadAdditionalSummaryDetails = async (formData) => {
    let response;
    try {
        response = await axios.post(`${REPORT_ACTIONS_API_URL}/body/co`,formData,{headers: getHeader()});
        if(response.data.success || response.data[0]['client_id']){
            return ({
                success:true,
                statusMessage:"Additional summary details added!!"
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error
            })
         }
        }
    catch (error){
        if(error.response){
            return ({
                success:false,
                statusMessage:error.response.data.error
            })
        } else if (error.request) {
            return {
                success: false,
                statusMessage: "Network error: Please check your internet connection.",
            };
        }
    }
};

export const uploadOtherTemplateDetails = async (formData) => {
    let response;
    try {
        response = await axios.post(`${REPORT_ACTIONS_API_URL}/body/both`,formData,{headers: getHeader()});
        if(response.data.success || response.data[0]['client_id']){
            return ({
                success:true,
                statusMessage:"Other Template Details Added!!"
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error
            })
         }
        }
    catch (error){
        return ({
            success:false,
            statusMessage:"Something Went Wrong. Please Try Again!"
        })
    }
};

export const uploadTranscription = async (formData) => {
    let response;
    try {
        response = await axios.post(`${REPORT_ACTIONS_API_URL}/transcription/transcribe/`, formData, { headers: getHeader() });
        if(response.data.success){
            return ({
                success: true,
                transcriptionText: response.data.transcriptionText,
                statusMessage:"Transcription Success"
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error? response.error : response.data.error
            })
        }

    } catch (error){
        return ({
            success:false,
            statusMessage:"Server error occurred"
        })
    }
};

export const uploadPDF = async (formData) => {
    let response;
    try {
        response = await axios.post(`${REPORT_ACTIONS_API_URL}/transcription/transcribePDF/`, formData, { headers: getHeader() });
        if(response.data.success){
            return ({
                success: true,
                transcriptionText: response.data.transcriptionText,
                statusMessage:"Transcription Success"
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error? response.error : response.data.error
            })
        }

    } catch (error){
        return ({
            success:false,
            statusMessage:"Server error occurred"
        })
    }
};

export const formatTranscription = async (formData) => {
    let response;
    try {
        response = await axios.post(`${REPORT_ACTIONS_API_URL}/transcription/format/`, formData, { headers: getHeader() });
        if(response.data.success){
            return ({
                success: true,
                formattedText: response.data.formattedText,
                statusMessage:"Format Success"
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error
            })
        }

    } catch (error){
        return ({
            success:false,
            statusMessage:"Something went wrong."
        })
    }
};


export const quickChangeLiability = async (formData) => {
    try {
        await axios.post(`${REPORT_ACTIONS_API_URL}/body/quickchange_liability`, formData , {headers: getHeader()});
        return ({
            success:true,
            statusMessage:"File Successfully uploaded"
        })
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};
export const checkLiability = async (formData) => {
    let response;
    try {
        response = await axios.post(`${REPORT_ACTIONS_API_URL}/transcription/liability/`, formData, { headers: getHeader() });
        if(response.data.success){
            return ({
                success: true,
                text: response.data.text,
                statusMessage:"Format Success"
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error
            })
        }

    } catch (error){
        return ({
            success:false,
            statusMessage:"Something went wrong."
        })
    }
};


// WEBPACK FOOTER //
// ./src/data/report_api.js